import React from "react";
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
import { useLocalStorage } from "./useLocalStorage";
import config from './config.json';

const Step19 = ({ nextStep,  setStep }) => {

  const currentStep = 19;
  const [dataLocal, setDataLocal] = useLocalStorage("audit_energetique", {
    heat_pump_surface: ""
  });

   const handleChange = (e) => {
    const { name, value } = e.target;
     setDataLocal({...dataLocal, [name]: value});
   };

   const tableauValeurs = JSON.parse(localStorage.getItem('work_types'));

   const prevSteps = () => {

    if(tableauValeurs.includes('pompe à chaleur air/eau')) {
     setStep(18);
    }
    else if(tableauValeurs.includes("isolation d'une toiture-terrasse")) {
     setStep(15);
    }
    else if(tableauValeurs.includes('fenêtres')) {
     setStep(14);
    }
    else if(tableauValeurs.includes('isolation du sol')) {
     setStep(13);
    }
    else if(tableauValeurs.includes('isolation des murs')) {
     setStep(11);
    }
    else if(tableauValeurs.includes('isolation des combles')) {
     setStep(9);
    } 
    else {
     setStep(6);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if(tableauValeurs.includes('Climatisation réversible')) {
     nextStep();
    } 
    else if(tableauValeurs.includes('pompe à chaleur hybride')) {
     setStep(21);
    } 
    else if(tableauValeurs.includes('Chaudière gaz à condensation')) {
     setStep(23);
    }
    else if(tableauValeurs.includes('radiateur électrique')) {
     setStep(25);
    }
    else if(tableauValeurs.includes('chaudière bois')) {
     setStep(26);
    }
    else if(tableauValeurs.includes('poêle à bois')) {
     setStep(28); 
    }
    else {
      setStep(29);
     }
  };

  return (
    <Container>
      <ProgressBar
        now={(currentStep / 36) * 100}
        style={{ backgroundColor: "#bad7f1" }}
      >
      <ProgressBar
        now={(currentStep / 36) * 100}
        style={{ backgroundColor: "#0be288" }}
      />
      </ProgressBar>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col>
              <h2>{config.step19.step}</h2>
              <h3>{config.step19.title}</h3>
          </Col>
        </Row>
        <Row className="mb-3 justify-content-center">
          <Col lg={6} offset-lg={3}>
            <Form.Label>{config.step19.label}</Form.Label>
              <Form.Control
              type="number"
              name="heat_pump_surface"
              value={dataLocal.heat_pump_surface}
              onChange={handleChange}
              required
            />
          </Col>
        </Row>
        <Row className="mt-3">
          <Col className="d-flex justify-content-between">
            <Button type="button" variant="secondary" onClick={prevSteps}>
              Précédent
            </Button>
            <Button type="submit" variant="primary" className="ms-3">
              Suivant
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default Step19;